import _toArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toArray";
import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { base64decode, base64encode } from "@protobuf-ts/runtime";
import { RpcError } from "@protobuf-ts/runtime-rpc";
import { GrpcStatusCode } from "./goog-grpc-status-code";
/**
 * Create fetch API headers for a grpc-web request.
 */

export function createGrpcWebRequestHeader(headers, format, timeout, meta, userAgent) {
  // add meta as headers
  if (meta) {
    for (var _i = 0, _Object$entries = Object.entries(meta); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          k = _Object$entries$_i[0],
          v = _Object$entries$_i[1];

      if (typeof v == "string") headers.append(k, v);else {
        var _iterator = _createForOfIteratorHelper(v),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            headers.append(k, i);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  } // set standard headers (possibly overwriting meta)


  headers.set('Content-Type', format === "text" ? "application/grpc-web-text" : "application/grpc-web+proto");

  if (format == "text") {
    // The client library should indicate to the server via the "Accept" header that
    // the response stream needs to be text encoded e.g. when XHR is used or due to
    // security policies with XHR
    headers.set("Accept", "application/grpc-web-text");
  }

  headers.set('X-Grpc-Web', "1");
  if (userAgent) headers.set("X-User-Agent", userAgent);

  if (typeof timeout === "number") {
    if (timeout <= 0) {
      // we raise an error ourselves because header "grpc-timeout" must be a positive integer
      throw new RpcError("timeout ".concat(timeout, " ms exceeded"), GrpcStatusCode[GrpcStatusCode.DEADLINE_EXCEEDED]);
    }

    headers.set('grpc-timeout', "".concat(timeout, "m"));
  } else if (timeout) {
    var deadline = timeout.getTime();
    var now = Date.now();

    if (deadline <= now) {
      // we raise an error ourselves because header "grpc-timeout" must be a positive integer
      throw new RpcError("deadline ".concat(timeout, " exceeded"), GrpcStatusCode[GrpcStatusCode.DEADLINE_EXCEEDED]);
    }

    headers.set('grpc-timeout', "".concat(deadline - now, "m"));
  }

  return headers;
}
export function createGrpcWebRequestBody(message, format) {
  var body = new Uint8Array(5 + message.length); // we need 5 bytes for frame type + message length

  body[0] = GrpcWebFrame.DATA; // first byte is frame type
  // 4 bytes message length

  for (var msgLen = message.length, i = 4; i > 0; i--) {
    body[i] = msgLen % 256;
    msgLen >>>= 8;
  }

  body.set(message, 5); // reset is message

  return format === "binary" ? body : base64encode(body);
}
export function readGrpcWebResponseHeader(headersOrFetchResponse, httpStatus, httpStatusText) {
  if (arguments.length === 1) {
    var fetchResponse = headersOrFetchResponse; // Cloudflare Workers throw when the type property of a fetch response
    // is accessed, so wrap access with try/catch. See:
    // * https://developers.cloudflare.com/workers/runtime-apis/response/#properties
    // * https://github.com/cloudflare/miniflare/blob/72f046e/packages/core/src/standards/http.ts#L646

    var responseType;

    try {
      responseType = fetchResponse.type;
    } catch (_a) {}

    switch (responseType) {
      case "error":
      case "opaque":
      case "opaqueredirect":
        // see https://developer.mozilla.org/en-US/docs/Web/API/Response/type
        throw new RpcError("fetch response type ".concat(fetchResponse.type), GrpcStatusCode[GrpcStatusCode.UNKNOWN]);
    }

    return readGrpcWebResponseHeader(fetchHeadersToHttp(fetchResponse.headers), fetchResponse.status, fetchResponse.statusText);
  }

  var headers = headersOrFetchResponse,
      httpOk = httpStatus >= 200 && httpStatus < 300,
      responseMeta = parseMetadata(headers),
      _parseStatus = parseStatus(headers),
      _parseStatus2 = _slicedToArray(_parseStatus, 2),
      statusCode = _parseStatus2[0],
      statusDetail = _parseStatus2[1];

  if ((statusCode === undefined || statusCode === GrpcStatusCode.OK) && !httpOk) {
    statusCode = httpStatusToGrpc(httpStatus);
    statusDetail = httpStatusText;
  }

  return [statusCode, statusDetail, responseMeta];
}
/**
 * Parses a grpc status (code and optional text) and meta data from response
 * trailers.
 *
 * Response trailers are expected as a byte array, but are actually just an
 * ASCII string with HTTP headers. Just pass the data of a grpc-web trailer
 * frame.
 */

export function readGrpcWebResponseTrailer(data) {
  var headers = parseTrailer(data),
      _parseStatus3 = parseStatus(headers),
      _parseStatus4 = _slicedToArray(_parseStatus3, 2),
      code = _parseStatus4[0],
      detail = _parseStatus4[1],
      meta = parseMetadata(headers);

  return [code !== null && code !== void 0 ? code : GrpcStatusCode.OK, detail, meta];
}
/**
 * A grpc-frame type. Can be used to determine type of frame emitted by
 * `readGrpcWebResponseBody()`.
 */

export var GrpcWebFrame;

(function (GrpcWebFrame) {
  GrpcWebFrame[GrpcWebFrame["DATA"] = 0] = "DATA";
  GrpcWebFrame[GrpcWebFrame["TRAILER"] = 128] = "TRAILER";
})(GrpcWebFrame || (GrpcWebFrame = {}));
/**
 * Parses a grpc-web response (unary or server streaming) from a fetch API
 * stream.
 *
 * Emits grpc-web frames.
 *
 * The returned promise resolves when the response is complete.
 */


export function readGrpcWebResponseBody(stream, contentType, onFrame) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var streamReader, base64queue, byteQueue, format, whatWgReadableStream, result, i, safeLen, msgLen, _i2;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            base64queue = "", byteQueue = new Uint8Array(0), format = parseFormat(contentType); // allows to read streams from the 'node-fetch' polyfill which uses
            // node.js ReadableStream instead of the what-wg streams api ReadableStream

            if (isReadableStream(stream)) {
              whatWgReadableStream = stream.getReader();
              streamReader = {
                next: function next() {
                  return whatWgReadableStream.read();
                }
              };
            } else {
              streamReader = stream[Symbol.asyncIterator]();
            }

          case 2:
            if (!true) {
              _context.next = 37;
              break;
            }

            _context.next = 5;
            return streamReader.next();

          case 5:
            result = _context.sent;

            if (!(result.value !== undefined)) {
              _context.next = 28;
              break;
            }

            if (!(format === "text")) {
              _context.next = 16;
              break;
            }

            // the statements below just decode base64 and append to `bytesUnread`
            // add incoming base64 to queue
            for (i = 0; i < result.value.length; i++) {
              base64queue += String.fromCharCode(result.value[i]);
            } // if the base64 queue is not a multiple of 4,
            // we have to wait for more data


            safeLen = base64queue.length - base64queue.length % 4;

            if (!(safeLen === 0)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("continue", 2);

          case 12:
            // decode safe chunk of base64 and add to byte queue
            byteQueue = concatBytes(byteQueue, base64decode(base64queue.substring(0, safeLen)));
            base64queue = base64queue.substring(safeLen);
            _context.next = 17;
            break;

          case 16:
            byteQueue = concatBytes(byteQueue, result.value);

          case 17:
            if (!(byteQueue.length >= 5 && byteQueue[0] === GrpcWebFrame.DATA)) {
              _context.next = 28;
              break;
            }

            msgLen = 0;

            for (_i2 = 1; _i2 < 5; _i2++) {
              msgLen = (msgLen << 8) + byteQueue[_i2];
            }

            if (!(byteQueue.length - 5 >= msgLen)) {
              _context.next = 25;
              break;
            }

            // we have the entire message
            onFrame(GrpcWebFrame.DATA, byteQueue.subarray(5, 5 + msgLen));
            byteQueue = byteQueue.subarray(5 + msgLen);
            _context.next = 26;
            break;

          case 25:
            return _context.abrupt("break", 28);

          case 26:
            _context.next = 17;
            break;

          case 28:
            if (!result.done) {
              _context.next = 35;
              break;
            }

            if (!(byteQueue.length === 0)) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("break", 37);

          case 31:
            if (!(byteQueue[0] !== GrpcWebFrame.TRAILER || byteQueue.length < 5)) {
              _context.next = 33;
              break;
            }

            throw new RpcError("premature EOF", GrpcStatusCode[GrpcStatusCode.DATA_LOSS]);

          case 33:
            onFrame(GrpcWebFrame.TRAILER, byteQueue.subarray(5));
            return _context.abrupt("break", 37);

          case 35:
            _context.next = 2;
            break;

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
} // internal

var isReadableStream = function isReadableStream(s) {
  return typeof s.getReader == "function";
}; // internal


function concatBytes(a, b) {
  var n = new Uint8Array(a.length + b.length);
  n.set(a);
  n.set(b, a.length);
  return n;
} // determines format from response "content-type" value.
// throws if value is unknown or missing.


function parseFormat(contentType) {
  // > the sender *should* always specify the message format, e.g. +proto, +json
  //
  // > the receiver should assume the default is "+proto" when the message format is
  // > missing in Content-Type (as "application/grpc-web")
  //
  // see https://github.com/grpc/grpc/blob/master/doc/PROTOCOL-WEB.md
  switch (contentType) {
    case "application/grpc-web-text":
    case "application/grpc-web-text+proto":
      return "text";

    case "application/grpc-web":
    case "application/grpc-web+proto":
      return "binary";

    case undefined:
    case null:
      throw new RpcError("missing response content type", GrpcStatusCode[GrpcStatusCode.INTERNAL]);

    default:
      throw new RpcError("unexpected response content type: " + contentType, GrpcStatusCode[GrpcStatusCode.INTERNAL]);
  }
} // returns error code on parse failure


function parseStatus(headers) {
  var code, message;
  var m = headers['grpc-message'];

  if (m !== undefined) {
    if (Array.isArray(m)) return [GrpcStatusCode.INTERNAL, "invalid grpc-web message"];
    message = m;
  }

  var s = headers['grpc-status'];

  if (s !== undefined) {
    if (Array.isArray(s)) return [GrpcStatusCode.INTERNAL, "invalid grpc-web status"];
    code = parseInt(s, 10);
    if (GrpcStatusCode[code] === undefined) return [GrpcStatusCode.INTERNAL, "invalid grpc-web status"];
  }

  return [code, message];
} // skips grpc-web headers


function parseMetadata(headers) {
  var meta = {};

  for (var _i3 = 0, _Object$entries2 = Object.entries(headers); _i3 < _Object$entries2.length; _i3++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
        k = _Object$entries2$_i[0],
        v = _Object$entries2$_i[1];

    switch (k) {
      case 'grpc-message':
      case 'grpc-status':
      case 'content-type':
        break;

      default:
        meta[k] = v;
    }
  }

  return meta;
} // parse trailer data (ASCII) to our headers rep


function parseTrailer(trailerData) {
  var headers = {};

  var _iterator2 = _createForOfIteratorHelper(String.fromCharCode.apply(String, trailerData).trim().split("\r\n")),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var chunk = _step2.value;
      if (chunk == "") continue;

      var _chunk$split = chunk.split(":"),
          _chunk$split2 = _toArray(_chunk$split),
          key = _chunk$split2[0],
          val = _chunk$split2.slice(1);

      var value = val.join(":").trim();
      key = key.trim();
      var e = headers[key];
      if (typeof e == "string") headers[key] = [e, value];else if (Array.isArray(e)) e.push(value);else headers[key] = value;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return headers;
} // fetch API to our headers rep


function fetchHeadersToHttp(fetchHeaders) {
  var headers = {};
  fetchHeaders.forEach(function (value, key) {
    var e = headers[key];
    if (typeof e == "string") headers[key] = [e, value];else if (Array.isArray(e)) e.push(value);else headers[key] = value;
  });
  return headers;
} // internal


function httpStatusToGrpc(httpStatus) {
  switch (httpStatus) {
    case 200:
      return GrpcStatusCode.OK;

    case 400:
      return GrpcStatusCode.INVALID_ARGUMENT;

    case 401:
      return GrpcStatusCode.UNAUTHENTICATED;

    case 403:
      return GrpcStatusCode.PERMISSION_DENIED;

    case 404:
      return GrpcStatusCode.NOT_FOUND;

    case 409:
      return GrpcStatusCode.ABORTED;

    case 412:
      return GrpcStatusCode.FAILED_PRECONDITION;

    case 429:
      return GrpcStatusCode.RESOURCE_EXHAUSTED;

    case 499:
      return GrpcStatusCode.CANCELLED;

    case 500:
      return GrpcStatusCode.UNKNOWN;

    case 501:
      return GrpcStatusCode.UNIMPLEMENTED;

    case 503:
      return GrpcStatusCode.UNAVAILABLE;

    case 504:
      return GrpcStatusCode.DEADLINE_EXCEEDED;

    default:
      return GrpcStatusCode.UNKNOWN;
  }
}